import { useEffect, startTransition } from 'react'

export function useAutoOpenPopover(
  isNewlyAdded: boolean,
  setOpen: (open: boolean) => void,
  onClearNewlyAdded?: () => void,
  delay = 100
) {
  useEffect(() => {
    if (isNewlyAdded) {
      setOpen(true)

      const timer = setTimeout(() => {
        startTransition(() => {
          onClearNewlyAdded?.()
        })
      }, delay)

      return () => clearTimeout(timer)
    }
  }, [isNewlyAdded, setOpen, onClearNewlyAdded, delay])
}
